<!--
  @Description 流程下发制单界面
  @Date 2022-02-22
  @Author liushuo

  // 1.权限控制
  1.1 制单人：其他操作
  1.2 编辑权限：检查、复查
  1.3 特殊权限：确认下发（确认下发后，除了打回按钮，其他都不可操作）

  // 2.问题汇总明细
  2.1 一旦有人签字确认，就不能新增或删除问题
-->
<template>
  <div class="card">
    <!-- #region 按钮组 -->
    <div class="buttonContainer">
      <div class="toolbar-dv">
        <toolBarBtn
          :parentData="this"
          :buttonVisible="buttonVisible"
          :moreButtonList="moreButtonList"
          ref="toolBarBtn"
        ></toolBarBtn>
      </div>
    </div>
    <!-- #endregion -->

    <!-- #region 主表 -->
    <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
      <!-- 第一行 -->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="编号" prop="num">
            <el-input
              v-model="form.num"
              autocomplete="off"
              :placeholder="placeholderConfig.autoCode"
              :disabled="true"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产品类型" prop="menuArgs">
            <el-select clearable v-model="form.menuArgs" :placeholder="placeholderConfig.relation" :disabled="true">
              <el-option
                v-for="i of ComBoxItems.menuArgs"
                :key="i.name + ''"
                :label="i.name"
                :value="i.value"
              ></el-option>
            </el-select>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="要求下发日期" prop="requestIssuedDate">
            <el-date-picker
              v-date
              v-model="form.requestIssuedDate"
              autocomplete="off"
              :placeholder="placeholderConfig.relation"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="true"
            ></el-date-picker>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="实际下发日期" prop="issuedDate">
            <el-date-picker
              v-date
              v-model="form.issuedDate"
              autocomplete="off"
              :placeholder="placeholderConfig.relation"
              type="date"
              value-format="yyyy-MM-dd"
              :disabled="true"
            ></el-date-picker>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="实际更新版本" prop="issuedVersion">
            <el-input
              v-model="form.issuedVersion"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || !isWriter || this.isIssued"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型" prop="issuedType">
            <el-input
              v-model="form.issuedType"
              autocomplete="off"
              :placeholder="placeholderConfig.relation"
              :disabled="true"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="下发企业" prop="companyName">
            <el-input
              v-model="form.companyName"
              autocomplete="off"
              :placeholder="placeholderConfig.relation"
              :disabled="true"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="主题" prop="subject">
            <el-input
              v-model="form.subject"
              autocomplete="off"
              :placeholder="placeholderConfig.input"
              :disabled="!Authority.edit || !isWriter || this.isIssued"
            ></el-input>
            <template slot="error" slot-scope="slot">
              <errorTooltip :content="slot.error"></errorTooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- #endregion -->

    <el-row :gutter="20">
      <!-- #region 问题明细 tab -->
      <el-col :span="rightTableVisible ? 9 : 23">
        <transition name="slide-fade">
          <div v-show="leftTableVisible">
            <el-tabs v-model="tabActiveName">
              <el-tab-pane label="问题汇总明细" name="question">
                <!-- <YKDivider content-position="left">问题汇总明细</YKDivider> -->
                <!-- 菜单权限明细table -->
                <vxe-grid
                  ref="xTable"
                  size="mini"
                  :column-config="{ minWidth: '80px' }"
                  border
                  keep-source
                  :height="tableHeight"
                  :cell-class-name="cellClassName"
                  resizable
                  :edit-rules="validRules"
                  show-overflow
                  :data="form.detailListCase"
                  highlight-hover-row
                  highlight-current-row
                  :mouse-config="{ area: true, extension: true }"
                  :edit-config="{
                    trigger: 'dblclick',
                    mode: 'cell',
                    activeMethod: activeMethod
                  }"
                  :keyboard-config="{
                    isArrow: true,
                    isEnter: true,
                    isTab: true,
                    isClip: true,
                    enterToTab: true,
                    isEdit: true,
                    editMethod: editMethod
                  }"
                  :menu-config="{
                    body: { options: bodyMenus },
                    visibleMethod: visibleMethod
                  }"
                  :columns="tableColumnsQuestion"
                  @menu-click="contextMenuClickEvent"
                  @cell-menu="cellContextMenuEvent"
                >
                </vxe-grid>
              </el-tab-pane>
              <el-tab-pane label="附件" name="attachment">
                <vxe-grid
                  ref="xTableAttachment"
                  size="mini"
                  :column-config="{ minWidth: '80px' }"
                  border
                  keep-source
                  :height="tableHeight"
                  :cell-class-name="cellClassName"
                  resizable
                  show-overflow
                  :data="attachmentList"
                  highlight-hover-row
                  highlight-current-row
                  :mouse-config="{ area: true, extension: true }"
                  :edit-config="{
                    trigger: 'dblclick',
                    mode: 'cell',
                    activeMethod: activeMethod
                  }"
                  :keyboard-config="{
                    isArrow: true,
                    isEnter: true,
                    isTab: true,
                    isClip: true,
                    enterToTab: true,
                    isEdit: true,
                    editMethod: editMethod
                  }"
                  :columns="tableColumnsAttachment"
                  :toolbar-config="tableToolbar"
                  @toolbar-button-click="toolbarButtonClickEvent"
                >
                </vxe-grid>
              </el-tab-pane>
            </el-tabs>
          </div>
        </transition>
      </el-col>
      <!-- #endregion -->

      <!-- #region 切换问题表格按钮 -->
      <el-col :span="1" class="expand-btn-dv" :style="{ height: tableHeight + 'px' }">
        <!-- 显示条件：1.两个都存在 2.右边存在且左边不存在 -->
        <el-tooltip
          class="item"
          effect="dark"
          :content="leftTableVisible ? '隐藏问题' : '显示问题'"
          placement="top"
          v-show="(rightTableVisible && leftTableVisible) || (rightTableVisible && !leftTableVisible)"
        >
          <div class="expand-btn" @click="changeLeftTableVisible" :style="{ height: tableHeight }">
            <i class="el-icon-caret-left" :class="{ 'rotate-icon': !leftTableVisible }"></i>
          </div>
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          :content="rightTableVisible ? '隐藏流程' : '显示流程'"
          placement="top"
          v-show="(rightTableVisible && leftTableVisible) || (!rightTableVisible && leftTableVisible)"
        >
          <div class="expand-btn" @click="changeRightTableVisible" :style="{ height: tableHeight }">
            <i class="el-icon-caret-right" :class="{ 'rotate-icon': !rightTableVisible }"></i>
          </div>
        </el-tooltip>
      </el-col>
      <!-- #endregion -->

      <!-- #region checklist tab -->
      <el-col :span="leftTableVisible ? 14 : 23">
        <transition name="slide-fade">
          <div
            class="detail-right-dv"
            :style="{
              height: tableHeight + this.$store.state.ykDivider + 'px'
            }"
            v-show="rightTableVisible"
          >
            <!-- 上半部 -->
            <el-row>
              <el-col :span="24">
                <YKDivider content-position="left">CheckList（通用）</YKDivider>
                <!-- 菜单权限明细table -->
                <!-- :height="checkListTableHeight" -->
                <vxe-grid
                  ref="xTableCheckMain"
                  size="mini"
                  :column-config="{ minWidth: '80px' }"
                  border
                  keep-source
                  :cell-class-name="cellClassName"
                  :cell-style="cellStyleCheckMain"
                  resizable
                  :edit-rules="validRulesCheckMain"
                  show-overflow
                  :data="form.detailListCheckList"
                  highlight-hover-row
                  highlight-current-row
                  :mouse-config="{ area: true, extension: true }"
                  :edit-config="{
                    trigger: 'dblclick',
                    mode: 'cell',
                    activeMethod: activeMethod
                  }"
                  :keyboard-config="{
                    isArrow: true,
                    isEnter: true,
                    isTab: true,
                    isClip: true,
                    enterToTab: true,
                    isEdit: true,
                    editMethod: editMethod
                  }"
                  :menu-config="{
                    body: { options: bodyMenusCheckMain },
                    visibleMethod: visibleMethodCheckMain
                  }"
                  :columns="tableColumnsCheckMain"
                  @menu-click="contextMenuClickEventCheckMain"
                  @cell-menu="cellContextMenuEventCheckMain"
                >
                </vxe-grid>
              </el-col>
            </el-row>
            <!-- 下半部 -->
            <el-row>
              <el-col :span="24">
                <YKDivider content-position="left">CheckList（按厂）</YKDivider>
                <!-- 菜单权限明细table -->
                <!-- :height="checkListTableHeight" -->
                <vxe-grid
                  ref="xTableCheckCompany"
                  size="mini"
                  :column-config="{ minWidth: '80px' }"
                  border
                  keep-source
                  :cell-class-name="cellClassName"
                  :cell-style="cellStyleCheckCompany"
                  resizable
                  :edit-rules="validRulesCheckCompany"
                  show-overflow
                  :data="dynamicCompanyData"
                  highlight-hover-row
                  highlight-current-row
                  :mouse-config="{ area: true, extension: true }"
                  :edit-config="{
                    trigger: 'dblclick',
                    mode: 'cell',
                    activeMethod: activeMethod
                  }"
                  :keyboard-config="{
                    isArrow: true,
                    isEnter: true,
                    isTab: true,
                    isClip: true,
                    enterToTab: true,
                    isEdit: true,
                    editMethod: editMethod
                  }"
                  :menu-config="{
                    body: { options: bodyMenusCheckCompany },
                    visibleMethod: visibleMethodCheckCompany
                  }"
                  :scroll-x="{
                    enabled: false
                  }"
                  :columns="tableColumnsCheckCompany"
                  @menu-click="contextMenuClickEventCheckCompany"
                  @cell-menu="cellContextMenuEventCheckCompany"
                >
                </vxe-grid>
              </el-col>
            </el-row>
          </div>
        </transition>
      </el-col>
      <!-- #endregion -->
    </el-row>

    <!-- #region 其他控件 -->
    <!-- 角色选择框 -->
    <EmployeeSelect ref="EmployeeSelect" :isMultiple="false" @sureBackPerson="sureBackPerson" />
    <!-- 批量输入 -->
    <BatchInput
      ref="BatchInput"
      @sureHandler="sureBackBatch"
      title="检查说明"
      inputLabel="说明"
      placeholder="确认后不可撤销，请谨慎填写"
    />

    <!-- 问题汇总选择框 -->
    <QuestionSelect
      ref="QuestionSelect"
      :menuArgs="form.menuArgs"
      :mainID="id"
      @sureHandle="sureBackQuestion"
    ></QuestionSelect>
    <!-- #endregion -->
    <!-- <FlowCancelModal ref="FlowCancelModal" :parentObj="this"></FlowCancelModal> -->
    <!-- 下发流程弹窗填写 -->
    <issueFlowEdit
      ref="issueFlowEdit"
      :modalTitle="issueFlowEditTitle"
      @refreshSingleForm="refreshSingleForm"
      @clearCheckBox="clearCheckBox"
    ></issueFlowEdit>

    <!-- 附件上传进度框 -->
    <vxe-modal v-model="showProress" title="进度" :showHeader="false" height="50" size="mini">
      <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage" :format="processStr"></el-progress>
    </vxe-modal>
    <!-- 选择文件夹 -->
    <input type="file" ref="uploadExcel" v-show="false" id="open" multiple="multiple" @change="uploadFile" />
  </div>
</template>

<script>
// import FlowCancelModal from './FlowCancelModal'
import { BASEURL } from '@/axios/baseUrlConfig.js'
import QuestionSelect from '@/components/Modal/Question/QuestionSelect'
import { TEXT_COLOR_MAP } from '@/public/params/global.js'
import issueFlowEdit from '../Summary/issueFlowEdit'

const CHECK = 'Check'
const REVIEW = 'Review'

export default {
  components: {
    QuestionSelect,
    issueFlowEdit
    // FlowCancelModal,
  },
  name: 'YKIssuedFlowDetail',
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {
          Authority: {
            edit: false,
            see: false
          }
        }
      }
    },
    joinID: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // ---- 按nginx进行上传的方式 -----
      // 是否显示进度
      showProress: false,
      // 当前显示进度字符串
      processStr: '',
      // 进度百分比
      percentage: 0,
      rowId: -1,
      // 总上传数量
      fileCount: 0,
      // 上传完成信息
      completeList: [],
      // 上传信息
      arrayUpload: [],
      // ---- 按nginx进行上传的方式 -----

      // 左侧表格是否显示
      leftTableVisible: true,
      rightTableVisible: true,
      // 当前激活tab
      tabActiveName: 'question',
      // tabel工具栏
      tableToolbar: {},
      // 下发流程弹窗的标题，默认 "流程打回"
      issueFlowEditTitle: '流程打回',
      id: 0,
      // 表单
      form: {
        num: '',
        requestIssuedDate: '',
        issuedDate: '',
        issuedVersion: '',
        menuArgs: '',
        issuedType: '',
        origYKIssuedFlowID: 0,
        companyName: '',
        id: 0,
        writer: '',
        writerID: 0,
        writeDate: '',
        locker: '',
        lockerID: 0,
        lockDate: '',
        detailListCase: [],
        detailListCheckList: [],
        detailListCompany: []
      },
      // 附件列表数据
      attachmentList: [],
      // 动态表格数据 - checkList（按厂）
      dynamicCompanyData: [],
      // 校验规则
      rules: {
        issuedVersion: [
          { required: true, message: '请输入实际更新版本', trigger: 'change' },
          {
            min: 0,
            max: 10,
            message: '实际更新版本长度应在 0 到 10 个字符',
            trigger: 'change'
          }
        ],
        subject: [
          {
            min: 0,
            max: 256,
            message: '主题长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ]
      },
      // 下拉框
      ComBoxItems: {
        menuArgs: []
      },
      // 校验-问题汇总
      validRules: {},
      // 校验-checklist（通用）
      validRulesCheckMain: {},
      // 校验-checklist（公司）
      validRulesCheckCompany: {},
      // 动态列-问题明细
      tableColumnsQuestion: [],
      // 动态列-附件
      tableColumnsAttachment: [],
      // checklist通用流程
      tableColumnsCheckMain: [],
      // checklist按厂流程
      tableColumnsCheckCompany: [],

      bodyMenus: [
        [
          {
            code: 'deleteMore',
            name: '批量删除'
          }
        ]
      ],
      bodyMenusCheckMain: [
        [
          {
            code: 'confirm',
            name: '检查确认'
          },
          {
            code: 'review',
            name: '复查确认'
          }
        ]
      ],
      bodyMenusCheckCompany: [
        [
          {
            code: 'confirm',
            name: '检查确认'
          },
          {
            code: 'review',
            name: '复查确认'
          }
        ]
      ],
      errIndex: [],
      // 右键缓存
      areas: {},
      colProperty: '',
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      buttonVisible: {
        add: false,
        save: false,
        delete: false,
        update: false,
        refresh: false,
        search: false,
        sort: false,
        lock: false,
        unlock: false,
        more: false
      },
      moreButtonList: [],
      // 是否绑定完成
      IfDataBindComplete: false,
      // 当前选中的表格（用于右键确认检查）
      curSelectTable: '',
      // 当前选中的操作[检查 | 复查]（用于右键确认检查或复查）
      curSelectMenuCode: '',
      // 特殊权限
      specialAuthority: {},
      // 是否拥有[问题汇总]的确认下发权限
      confirmIssuedAuthority: false,
      // 所有下发流程ID
      allIssuedFlowID: []
    }
  },
  created() {
    this.InitColumn()
    this.BindComBox()
    this.id = this.joinID ? this.joinID : 0
    this.BindText()
    this.initSettings()
    this.getAllIssuedFlow()
  },
  activated() {
    // 可能存在情况：已打开流程下发的明细界面，并跳转到汇总界面选择流程下发，跳转后需在activated重新绑定数据，才能展示新生成的单据
    if (this.$route.params?.id > 0) {
      this.refreshSingleForm(this.$route.params?.id)
    }
  },
  mounted() {},
  methods: {
    initSettings() {
      this.tableToolbar = {
        buttons: [
          {
            code: 'openUpload',
            name: '上传',
            disabled: !this.Authority.edit || this.isIssued
          }
        ]
      }
    },
    // table工具栏方法
    toolbarButtonClickEvent({ code }) {
      switch (code) {
        case 'openUpload':
          this.$refs.uploadExcel.click()
          break
      }
    },
    getIssueSpecialAuthority() {
      // [问题汇总]界面的路由参数
      const summaryRoutePath = '/290612199861c31d1036b185b4e69b75'
      const summaryAuthority = this.AuthorityFilter(summaryRoutePath)
      this.confirmIssuedAuthority = summaryAuthority.special.find(v => v.name === 'confirmIssued')
    },
    refreshSingleForm(id) {
      this.id = id
      this.BindText()
    },
    // 获取数据
    async BindText() {
      this.IfDataBindComplete = false
      if (this.id > 0) {
        const { data: res } = await this.$http.get('/Common/YKIssuedFlow/both', {
          params: {
            id: this.id
          }
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        this.form = res.data
        this.handleColumns(res.data.detailListCompany)

        // 获取附件
        this.attachmentList = await this.getCommonAttachments('YKIssuedFlow', this.id)
      } else {
        this.form = {
          menuArgs: '',
          issuedVersion: '',
          subject: '',
          companyName: '',
          detailListCase: [],
          detailListCheckList: [],
          detailListCompany: []
        }
      }
      this.InitRight()
      this.$nextTick(() => {
        this.IfDataBindComplete = true
        this.IfExistModify = false
      })
    },
    // 获取权限
    InitRight() {
      // 权限最先获取，才能根据权限来初始化按钮和列的状态
      this.getSpecial()
      this.getIssueSpecialAuthority()

      this.moreButtonList = [
        {
          name: '保存',
          icon: 'el-icon-folder-checked',
          disabled: !this.Authority.edit || !this.isWriter || this.isIssued,
          event: 'save'
        },
        {
          name: '上一条',
          icon: 'el-icon-top',
          disabled: this.currentIDPos !== -1 && this.currentIDPos === 0,
          event: 'toBefore'
        },
        {
          name: '下一条',
          icon: 'el-icon-bottom',
          disabled: this.currentIDPos !== -1 && this.currentIDPos === this.allIssuedFlowID.length - 1,
          event: 'toNext'
        },
        {
          name: '删除',
          icon: 'el-icon-delete',
          disabled: this.id === 0 || !this.Authority.edit || !this.isWriter,
          event: 'delete'
        },
        {
          name: '新增问题',
          icon: 'el-icon-document',
          // 下发后能否新增问题 —— 不能
          disabled: !this.Authority.edit || !this.isWriter || this.isIssued,
          event: 'handleOpenFile'
        },
        {
          name: '流程打回',
          icon: 'iconfont fjyk-OA-back',
          disabled:
            !this.Authority.edit ||
            !this.isWriter ||
            // 已下发了的流程才能打回
            !this.isIssued,
          event: 'handleCancelFlow'
        },
        {
          name: '复制下发',
          icon: 'el-icon-copy-document',
          disabled: !this.confirmIssuedAuthority,
          event: 'handleCopy'
        },
        {
          name: '确认下发',
          icon: 'el-icon-finished',
          // 特殊权限才可确认下发
          disabled: !this.specialAuthority.issued || this.isIssued,
          event: 'confirmFinish'
        },
        {
          name: '返回',
          icon: 'iconfont fjyk-back',
          event: 'back'
        }
      ]
      this.InitColumn()
    },
    // 获取特殊权限，格式如：specialAuthority:{ '权限名称':true }
    getSpecial() {
      this.Authority.special.forEach(v => {
        this.specialAuthority[v.name] = true
      })
    },
    // 初始化
    InitColumn() {
      // 问题明细
      this.tableColumnsQuestion = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        {
          type: 'checkbox',
          width: '50px',
          visible: this.Authority.edit && this.isWriter
        },
        {
          field: 'delete',
          title: '删除',
          visible: this.Authority.edit && this.isWriter && !this.isIssued,
          width: '50',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.removeDetail([row.id])
                    // this.removeRowForTable(row, this.$refs.xTable, this.$data)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          title: '问题编号',
          width: 55,
          field: 'num',
          filters: [{ data: { val1: '', val2: '' } }],
          filterRender: { name: 'FilterInputRange' }
        },
        {
          title: '系统版本',
          width: 70,
          field: 'productionVersion',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '模块',
          width: 90,
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '页面',
          width: 90,
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '问题内容',
          minWidth: 150,
          field: 'content',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          title: '紧急',
          width: 40,
          field: 'isPriority',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '类型',
          width: 45,
          field: 'type',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '提出人',
          width: 60,
          field: 'createtor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端研发',
          width: 70,
          field: 'frontEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端研发',
          width: 70,
          field: 'backEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试',
          width: 70,
          field: 'techTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试',
          width: 70,
          field: 'businessTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        }
      ]

      // 附件
      this.tableColumnsAttachment = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [
                  <el-tooltip class='tooltipItem' effect='light' content={row.repeatText} placement='right'>
                    <div style='width: 100%; height: 100%'>
                      <span>{this.$refs.xTableAttachment.getVTRowIndex(row) + 1}</span>
                    </div>
                  </el-tooltip>
                ]
              } else {
                return [<span>{this.$refs.xTableAttachment.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        {
          field: 'delete',
          title: '删除',
          visible: this.Authority.edit && !this.isIssued,
          width: '50',
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id='vxeDelete'
                  class='el-icon-delete-solid'
                  onClick={() => {
                    this.$messagebox
                      .confirm('确定删除附件吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      })
                      .then(async () => {
                        const res = await this.removeAttachmentOne(row.id)
                        if (!res.isSuccess) {
                          this.$message.error(res.errorMessage)
                          return false
                        }
                        this.$message.success(res.data)
                        this.BindText()
                      })
                  }}
                ></i>
              ]
            }
          }
        },
        {
          title: '下载',
          align: 'center',
          width: '50',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  class='el-icon-download'
                  onClick={() => {
                    this.handleDown(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          field: 'display',
          title: '文件名'
        },
        {
          field: 'type',
          title: '文件类型'
        },
        {
          field: 'fileSize',
          title: '文件大小'
        },
        {
          field: 'eName',
          title: '上传人姓名'
        },
        {
          field: 'uploadTime',
          title: '上传时间',
          width: 150,
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        },
        {
          field: 'memo',
          title: '备注'
        }
      ]

      // checklist-通用流程
      this.tableColumnsCheckMain = [
        {
          field: 'sort',
          title: '序号',
          fixed: 'left',
          width: 50
        },
        {
          field: 'checkItem',
          title: '检查项目',
          fixed: 'left',
          width: 200
        },
        {
          field: 'checker',
          title: '检查人'
        },
        {
          field: 'checkerID',
          visible: false,
          title: '检查人标识'
        },
        {
          field: 'checkNote',
          title: '检查人说明',
          minWidth: 250
        },
        {
          field: 'checkTime',
          title: '检查时间',
          width: 150,
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        },
        {
          field: 'reviewer',
          title: '复查人'
        },
        {
          field: 'reviewerID',
          title: '复查人标识',
          visible: false
        },
        {
          field: 'reviewNote',
          title: '复查人说明',
          minWidth: 250
        },
        {
          field: 'reviewTime',
          title: '复查时间',
          width: 150,
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        }
      ]
    },
    save() {
      this.validEnter().then(async result => {
        if (result) {
          this.update()
        }
      })
    },
    // 修改
    async update() {
      let form = { ...this.form }
      form = this.removeObjectNull(form)
      const { data: res } = await this.$http.put('/Common/YKIssuedFlow/both', form)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return
      }
      this.$message.success(this.messageConfig.save.success)
      this.BindText()
    },
    // 锁定
    async lock() {
      const { data: res } = await this.$http.put('/Common/BMenuGroup/lock', {
        id: this.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('锁定成功！')
      this.BindText()
    },
    // 解锁
    async unlock() {
      const { data: res } = await this.$http.put('/Common/BMenuGroup/unlock', {
        id: this.id,
        effectCondition: this.Authority.alEffectCondition
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success('解锁成功！')
      this.BindText()
    },
    // 验证
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      this.errIndex = []
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      // 重复行
      // this.repeatForTable(this.errIndex, this.$refs.xTable, ['groupName', 'vuePath'])
      if (this.errIndex.length > 0) {
        flag = false
        this.$message.error('验证失败,请核对输入数据')
        return false
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // table 点击删除列
    delete() {
      this.$confirm('确定要删除本张单据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.sureDelete()
        })
        .catch(() => {})
    },
    async sureDelete() {
      const that = this
      const { data: res } = await that.$http.delete('/Common/YKIssuedFlow', {
        data: {
          id: that.id,
          issuedFlowNum: that.form.num,
          effectCondition: that.Authority.alEffectCondition,
          empower: []
        }
      })
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.del.success)
        that.IfExistModify = false
        that.back('del')
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    back(type) {
      if (this.IfExistModify) {
        this.$confirm('您已做出修改，是否关闭？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            switch (type) {
              case 'del':
                this.$emit('SingleBack', -1)
                break
              default:
                this.$emit('SingleBack', this.id)
                break
            }
          })
          .catch(() => {})
      } else {
        switch (type) {
          case 'del':
            this.$emit('SingleBack', -1)
            break
          default:
            this.$emit('SingleBack', this.id)
            break
        }
      }
    },
    // 按下右键缓存选中列（问题汇总明细）
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
    },
    // 按下右键缓存选中列（checkList通用）
    cellContextMenuEventCheckMain({ column }) {
      this.areas = this.$refs.xTableCheckMain.getCellAreas()
      this.colProperty = column.property
    },
    // 按下右键缓存选中列（checkList按厂）
    cellContextMenuEventCheckCompany({ column }) {
      this.areas = this.$refs.xTableCheckCompany.getCellAreas()
      this.colProperty = column.property
    },
    // 返回人员
    sureBackPerson(obj) {
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            if (col.property === this.colProperty) {
              row[this.colProperty] = obj.name
            }
          }
        }
      })
    },
    // 绑定下拉框
    async BindComBox() {
      this.ComBoxItems.menuArgs = []
      const { data: selectRes } = await this.$http.get('/Common/BMenuGroup/select-item')
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'ProductionType':
              this.ComBoxItems.menuArgs.push(item)
              break
          }
        }
      }
    },
    // 单元格设置样式,错误提示
    cellClassName({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
    // cell激活控制
    activeMethod({ column }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (!this.Authority.edit || this.isWriter) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (column.editRender && column.editRender.attrs && column.editRender.attrs.disabled === true) {
        return false
      }
      if (!this.Authority.edit || this.isWriter) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 右键菜单是否显示（问题汇总tab）
    visibleMethod({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          // 不可编辑条件：无编辑权限 | 非制单人本人 | 已下发
          item.disabled = !this.Authority.edit || !this.isWriter || this.isIssued
          if (!column) {
            item.visible = false
          }
          item.visible = true
        })
      })
      return true
    },
    // 右键菜单是否显示（checkList通用）
    visibleMethodCheckMain({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.Authority.edit || this.isIssued
          if (!column) {
            item.visible = false
          } else if (['checker', 'checkNote', 'checkTime'].includes(column.property)) {
            // 检查
            item.visible = item.code === 'confirm'
          } else if (['reviewer', 'reviewNote', 'reviewTime'].includes(column.property)) {
            // 复查
            item.visible = item.code === 'review'
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键菜单是否显示（checkList公司）
    visibleMethodCheckCompany({ options, column }) {
      options.forEach(list => {
        list.forEach(item => {
          item.disabled = !this.Authority.edit || this.isIssued
          if (!column) {
            item.visible = false
          } else if (column.property.indexOf(CHECK) > -1) {
            // 检查
            item.visible = item.code === 'confirm'
          } else if (column.property.indexOf(REVIEW) > -1) {
            // 复查
            item.visible = item.code === 'review'
          }
        })
      })
      return true
    },
    // 右键点击事件（问题汇总）
    contextMenuClickEvent({ menu }) {
      switch (menu.code) {
        case 'deleteMore':
          this.deleteMore()
          break
      }
    },
    // 右键点击事件（checkList通用）
    contextMenuClickEventCheckMain({ menu }) {
      switch (menu.code) {
        case 'confirm':
          this.openBatchInput('confirm', 'main')
          break
        case 'review':
          this.openBatchInput('review', 'main')
          break
      }
    },
    // 右键点击事件（checkList按厂）
    contextMenuClickEventCheckCompany({ menu }) {
      switch (menu.code) {
        case 'confirm':
          this.openBatchInput('confirm', 'company')
          break
        case 'review':
          this.openBatchInput('review', 'company')
          break
      }
    },
    // 判断当前item是否与本账号有关(通用)
    isNeedCurrentUserHandleCompany(item, userID) {
      let userIDList = []
      Object.entries(item).forEach(([key, value]) => {
        if (key.includes('CheckerID') || key.includes('ReviewerID')) {
          userIDList.push(value)
        }
      })
      return userIDList.includes(userID)
    },

    // 打开批量输入
    openBatchInput(menuCode, tableName) {
      this.curSelectTable = tableName
      this.curSelectMenuCode = menuCode
      this.$refs.BatchInput.formVisible = true
    },
    // 批量输入返回
    sureBackBatch(inputValue) {
      if (this.curSelectTable === 'main') {
        const idList = this.getAreasIDList('id', true)
        const sortList = this.getAreasIDList('sort', true)
        if (idList.length <= 0) {
          this.$message.warning('选中行没有需要您操作的数据哦~')
          return
        }
        // 1.checkList（通用）
        this.confirmMain(idList, inputValue, sortList)
      } else if (this.curSelectTable === 'company') {
        // 2.checkList（按厂）
        // const sortID = this.getAreasIDList('Sort')
        this.confirmCompany(inputValue)
      }
    },
    /**
     * 检查和复查确认（checkList通用）
     * @param {Array<int>} idList 明细id
     * @param {String} inputValue 说明
     * @param {Array<int>} sortList 序号List
     */
    async confirmMain(idList, inputValue, sortList = []) {
      const url = {
        confirm: 'checklist-confirm',
        review: 'checklist-review'
      }

      const { data: res } = await this.$http.put(`/Common/YKIssuedFlow/${url[this.curSelectMenuCode]}`, {
        idList,
        sortList,
        issuedFlowNum: this.form.num,
        note: inputValue
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.BindText()
    },
    /**
     * 检查和复查确认（checkList按厂）
     * @param {String} inputValue 说明
     */
    async confirmCompany(inputValue) {
      let confirmList = []
      let repeatMap = new Map()
      const url = {
        confirm: 'company-confirm',
        review: 'company-review'
      }

      // 构造请求参数
      this.areas.forEach(area => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            const company = this.getSplitCompany(col.property)
            // 判重（唯一条件：序号ID + 公司名），避免区域拉选后，因为存在[检查人、检查人说明、检查时间]多个字段，导致会构造出重复的参数
            if (repeatMap.has(row.Sort + company)) {
              continue
            } else {
              repeatMap.set(row.Sort + company, true)

              if (this.isNeedCurrentUserHandleCompany(row, this.$store.state.userInfo.userId)) {
                confirmList.push({
                  ykIssuedFlowID: this.id,
                  sort: row.Sort,
                  company,
                  note: inputValue
                })
              }
            }
          }
        }
      })
      if (confirmList.length <= 0) {
        this.$message.warning('选中行没有需要您操作的数据哦~')
        return
      }
      // 发起请求
      const { data: res } = await this.$http.put(`/Common/YKIssuedFlow/${url[this.curSelectMenuCode]}`, confirmList, {
        headers: {
          issuedFlowNum: this.form.num // 用于写入系统日志
        }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.BindText()
    },
    // 将"company_Review"中的company取出来
    getSplitCompany(value) {
      return value.split('_')[0] || ''
    },
    // 打开问题汇总选择框
    handleOpenFile() {
      this.$refs.QuestionSelect.formVisible = true
    },
    // 问题汇总选择框返回值
    sureBackQuestion(selectRecords) {
      if (selectRecords.length > 0) {
        let idList = []
        selectRecords.forEach(row => {
          idList.push(row.id)
        })
        this.addDetail(idList)
      }
    },
    // 新增问题汇总明细
    async addDetail(idList) {
      const { data: res } = await this.$http.put('/Common/YKIssuedFlow/append-case', {
        id: this.id,
        idList
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.BindText()
    },
    // 切换左侧表格显示隐藏
    changeLeftTableVisible() {
      this.leftTableVisible = !this.leftTableVisible
    },
    // 切换左侧表格显示隐藏
    changeRightTableVisible() {
      this.rightTableVisible = !this.rightTableVisible
    },
    // 流程打回
    handleCancelFlow() {
      const checkedRecords = this.$refs.xTable.getCheckboxRecords()
      if (!this.validIsCanCancelFlow(checkedRecords)) {
        return false
      }
      // 配置打回流程弹窗数据
      this.setIssueModalData(checkedRecords)
      this.$nextTick(() => {
        // 打开弹窗
        this.openIssueFlowEditModal()
      })
    },
    // 配置打回流程弹窗数据
    setIssueModalData(checkRecords = []) {
      let idList = []
      checkRecords.forEach(row => {
        // ykCaseID 原问题编号
        idList.push(row.ykCaseID)
      })
      this.issueFlowEditTitle = '流程打回'
      this.$refs.issueFlowEdit.idList = idList
      // 产品类型
      this.$refs.issueFlowEdit.menuArgs = this.form.menuArgs
      // 下发类型
      this.$refs.issueFlowEdit.issuedType = '打回'
      // 当前操作类型
      this.$refs.issueFlowEdit.curOperateType = '打回'
      // 主表ID
      this.$refs.issueFlowEdit.origYKIssuedFlowID = this.id
    },
    // 打开下发流程弹窗弹窗（填写实际更新版本和备注）
    openIssueFlowEditModal() {
      this.$refs.issueFlowEdit.isShow = !this.$refs.issueFlowEdit.isShow
    },
    validIsCanCancelFlow(records) {
      if (records.length === 0) {
        this.$message.warning('请选择要打回的问题编号')
        return false
      }
      return true
    },
    // 处理[复制单据]逻辑
    handleCopy() {
      // 配置打回流程弹窗数据
      this.setIssueModalDataCopy()
      this.$nextTick(() => {
        // 打开弹窗
        this.openIssueFlowEditModal()
      })
    },
    // 配置打回流程弹窗数据 - [复制单据]
    setIssueModalDataCopy() {
      let idList = []
      this.form.detailListCase.forEach(row => {
        // ykCaseID 原问题编号
        idList.push(row.ykCaseID)
      })
      this.issueFlowEditTitle = '单据复制'
      this.$refs.issueFlowEdit.idList = idList
      // 产品类型
      this.$refs.issueFlowEdit.menuArgs = this.form.menuArgs
      // 下发类型
      this.$refs.issueFlowEdit.issuedType = '正常'
      // 当前操作类型
      this.$refs.issueFlowEdit.curOperateType = '复制'
      // 主表ID（复制单据，该ID默认为0即可）
      this.$refs.issueFlowEdit.origYKIssuedFlowID = 0
    },
    // 动态列处理
    handleColumns(detailList) {
      this.validRulesCheckCompany = {}
      // 序号列
      this.tableColumnsCheckCompany = []
      // 处理列名
      for (let item of detailList.cols) {
        let column = {
          field: item.field,
          title: item.title,
          visible: item.visible,
          // 自定义参数params
          params: item.comboboxCode
        }
        if (item.type !== '') {
          column['editRender'] = {
            name: item.type
          }
        }
        // 序号列宽度
        if (item.field === 'Sort') {
          column['width'] = 50
        } else if (item.field === 'CheckItem') {
          column['width'] = 200
        }

        // 动态规则
        let { col, validRules } = this.setColumnByType(item)
        Object.assign(this.validRulesCheckCompany, validRules)
        Object.assign(column, col)

        if (item.children) {
          let children = []
          item.children.forEach(i => {
            let childColumn = {
              field: i.field,
              title: i.title,
              visible: i.visible,
              params: i.comboboxCode
            }
            // 动态规则
            let { col, validRules } = this.setColumnByType(i)
            Object.assign(this.validRulesCheckCompany, validRules)
            Object.assign(childColumn, col)

            children.push(childColumn)
          })

          // 子列头赋值
          column['children'] = children
        }
        this.tableColumnsCheckCompany.push(column)
      }
      this.dynamicCompanyData = JSON.parse(detailList.dtJsonStr)
    },
    // 设置动态列的渲染规则
    setColumnByType(item) {
      let validRules = {}
      let col = {}

      switch (item.valueType) {
        case 'string':
          validRules[item.field] = [
            {
              min: 0,
              max: item.length,
              message: '长度在 0 到 ' + item.length + ' 个字符',
              trigger: 'change'
            }
          ]
          break
        case 'int':
          validRules[item.field] = [
            {
              validator: this.isInteger,
              validNumerical: this.validNumerical.nonNegative,
              trigger: 'change'
            }
          ]
          break
        case 'decimal':
          validRules[item.field] = [
            {
              validator: this.isDecimal,
              validNumerical: this.validNumerical.nonNegative,
              length: item.length,
              decimalLength: item.numberLength,
              trigger: 'change'
            }
          ]
          break
        case 'datetime':
          col['formatter'] = ['formatDate', 'yyyy-MM-dd HH:mm:ss']
          break
      }
      return {
        validRules,
        col
      }
    },
    // 删除多行明细行（问题汇总tab）
    deleteMore() {
      const idList = this.getAreasIDList()
      this.removeDetail(idList)
    },
    // 删除明细行（问题汇总tab）
    removeDetail(idList) {
      this.$messagebox
        .confirm('确定删除明细吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          const { data: res } = await this.$http.put('/Common/YKIssuedFlow/remove-detail', {
            id: this.id,
            idList
          })
          if (!res.isSuccess) {
            this.$message.error(res.errorMessage)
            return false
          }
          this.$message.success(res.data)
          this.BindText()
        })
    },
    // 保存所拉选的行ID
    // isFilterMyself: 是否过滤只含自己的数据
    getAreasIDList(params = 'id', isFilterMyself = false) {
      let res = []
      // 将行id保存
      this.areas.forEach(area => {
        for (let row of area.rows) {
          if (isFilterMyself) {
            // 判断当前item是否与本账号有关
            const isNeedCurrentUserHandle = [row.checkerID, row.reviewerID].includes(this.$store.state.userInfo.userId)
            if (isNeedCurrentUserHandle) {
              res.push(row[params])
            }
          } else {
            res.push(row[params])
          }
        }
      })
      return res
    },
    // 单元格样式（通用）
    cellStyleCheckMain({ column, row }) {
      // 被打回的责任人行，用灰色底色区分
      if (row['sort'] === 0) {
        return {
          backgroundColor: '#f2f3f5'
        }
      }

      // 检查
      if (
        ['checker', 'checkTime', 'checkNote'].includes(column.property) &&
        this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row['checkTime']) !== ''
      ) {
        return {
          color: TEXT_COLOR_MAP.GREEN
        }
      }
      // 复查
      if (
        ['reviewer', 'reviewTime', 'reviewNote'].includes(column.property) &&
        this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row['reviewTime']) !== ''
      ) {
        return {
          color: TEXT_COLOR_MAP.GREEN
        }
      }
    },
    // 单元格样式（按厂）
    cellStyleCheckCompany({ column, row }) {
      // 列名为：南安_CheckTime；分离出公司名用于拼接 [日期] 的字段
      const company = column.property.split('_')[0] || ''
      // 检查
      if (
        (column.property.indexOf('Checker') > -1 ||
          column.property.indexOf('CheckTime') > -1 ||
          column.property.indexOf('CheckNote') > -1) &&
        this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row[company + '_CheckTime']) !== ''
      ) {
        return {
          color: TEXT_COLOR_MAP.GREEN
        }
      }
      // 复查
      if (
        (column.property.indexOf('Reviewer') > -1 ||
          column.property.indexOf('ReviewTime') > -1 ||
          column.property.indexOf('ReviewNote') > -1) &&
        this.ykDateFormat('yyyy-MM-dd HH:mm:ss', row[company + '_ReviewTime']) !== ''
      ) {
        return {
          color: TEXT_COLOR_MAP.GREEN
        }
      }
    },
    // 确认下发
    confirmFinish() {
      this.$messagebox
        .confirm('下发后不可撤销，确认下发吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          // 确认下发是否成功（返回来的数组长度大于0）
          let idList = await this.httpConfirmFinish()
          // 反写反馈系统
          idList.length > 0 && this.httpIssuesActual(idList)
        })
    },
    // 确认下发请求发起
    async httpConfirmFinish() {
      const { data: res } = await this.$http.put(`/Common/YKIssuedFlow/issued/${this.id}`, {
        issuedFlowNum: this.form.num // 用于写入系统日志
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return []
      }
      this.$message.success('下发成功')
      return res.data
    },
    // 确认下发后，反写反馈系统
    async httpIssuesActual(idList) {
      const { data: res } = await this.$http.put(
        '/Bugs/YKBug/issues-actual',
        {
          // idList 是根据确认下发后,后端返回来的结果再赋值回去
          idList,
          issuedVersion: this.form.issuedVersion
        },
        {
          headers: { bugsManagement: true }
        }
      )
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.BindText()
    },
    // 清空复选框
    clearCheckBox() {
      this.$refs.xTable.clearCheckboxRow()
    },
    // 获取ID列表，用逗号分隔
    getIDList() {
      let res = []
      this.form.detailListCase.forEach(row => {
        res.push(row.ykCaseID)
      })
      return res
    },
    // 获取所有下发流程（供上一条、下一条使用）
    async getAllIssuedFlow() {
      const { data: res } = await this.$http.post('/Common/YKIssuedFlow/list', {
        pageIndex: 1,
        pageSize: 999999,
        seeType: this.Authority.seeType
      })
      if (!res.isSuccess) {
        return false
      }
      this.allIssuedFlowID = res.data.rows.map(row => {
        return row.id
      })
    },
    toBefore() {
      this.id = this.getBeforeOrNextID('before')
      this.BindText()
    },
    toNext() {
      this.id = this.getBeforeOrNextID('next')
      this.BindText()
    },

    // 获取上一条或下一条的ID
    getBeforeOrNextID(type = 'before') {
      // 可以跳转的条件：上一条或下一条有值
      if (type === 'before') {
        return this.allIssuedFlowID[this.currentIDPos - 1]
      } else if (type === 'next') {
        return this.allIssuedFlowID[this.currentIDPos + 1]
      }
    },
    async uploadFile(event) {
      const files = event.target.files
      if (files.length === 0) {
        return
      }

      this.fileCount = files.length
      this.completeList = []
      this.arrayUpload = []
      this.percentage = 0
      this.processStr = `${this.percentage}%`
      for (let fileObj of files) {
        this.uploadSingle(fileObj)
      }
      event.target.value = ''
    },
    // 上传文件到nginx上
    uploadSingle(fileObj) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const that = this
      const guID = that.guid()
      let formData = new FormData()
      formData.append('file', fileObj)
      formData.append('vuePathName', '')
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'accept-language': 'zh-CN',
          'loading': false
        },
        timeout: 0
      }
      that.$http
        .post(`${upload}/upload?X-Progress-ID=${guID}`, formData, config)
        .then(({ data: res }) => {
          if (res.isSuccess) {
            that.completeList.push(res.data)
            if (that.completeList.length === that.fileCount) {
              that.writeToDB()
            }
          } else {
            that.$message.error(res.errorMessage)
          }
        })
        .catch(err => {
          that.$message.error(err)
        })
      let timer = setInterval(async () => {
        let { data: res } = await that.$http.get(`${upload}/api/progress?X-Progress-ID=${guID}`, {
          headers: { loading: false }
        })
        res = res.replace('(', '')
        res = res.replace(')', '')
        res = res.replace(';', '')
        res = JSON.parse(res)
        if (res.state === 'uploading') {
          let pre = 100
          if (res.size > 0) {
            pre = res.received / res.size
            pre = (pre * 100).toFixed(2)
            if (res.received < res.size && pre === 100) {
              pre = 99.99
            }
          }
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = pre
          }
          that.pre()
        } else {
          let option = that.arrayUpload.filter(item => {
            return item.guID === guID
          })
          if (option.length > 0) {
            option[0].pre = 100
          }
          that.pre()
          clearInterval(timer)
        }
      }, 1000)
      that.arrayUpload.push({ guID: guID, timer: timer, pre: 0 })
      setTimeout(() => {
        if (that.percentage < 100) {
          that.showProress = true
        }
      }, 500)
    },
    // 计算上传总进度
    pre() {
      let that = this
      let sumPre = this.$utils.sum(that.arrayUpload, 'pre')
      that.percentage = sumPre / that.fileCount
      that.processStr = `${that.percentage}%`
    },
    // 写入应用服务器
    async writeToDB() {
      let that = this
      that.arrayUpload.forEach(item => {
        if (item.timer) {
          clearInterval(item.timer)
        }
      })
      const fileList = that.completeList.map(item => {
        const temp = {
          keyValue: this.id,
          fileName: item.aDisplay,
          display: item.aDisplay + item.aType,
          fileClass: 'YKIssuedFlow',
          filePath: item.aPath,
          type: item.aType,
          fileSize: item.aSize,
          byteSize: item.aLength
        }
        return temp
      })

      const isSuccess = await this.uploadAttachments(fileList)
      if (isSuccess) {
        that.$message.success('上传成功')
        that.BindText()
      }

      that.percentage = 100
      that.completeList = []
      that.arrayUpload = []
      that.showProress = false
    },
    guid() {
      var guid = ''
      for (var i = 1; i <= 32; i++) {
        var n = Math.floor(Math.random() * 16.0).toString(16)
        guid += n
        if (i === 8 || i === 12 || i === 16 || i === 20) guid += '-'
      }
      return guid
    },
    // 下载
    async handleDown(row) {
      let that = this
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      const { data: res } = await that.$http.get(`/Base/BAttachment/secret`, {
        params: {
          link: `${upload}/download/${row.filePath}`
        }
      })

      let aFileType = row.type.toUpperCase()
      if (['HTML', 'TXT', 'JPG', 'JPEG', 'PNG', 'JIFF', 'ART', 'AU', 'AIFF', 'XBM', 'PDF'].includes(aFileType)) {
        const a = document.createElement('a')
        const url = res // 完整的url则直接使用
        // 这里是将url转成blob地址，
        fetch(url)
          .then(res => res.blob())
          .then(blob => {
            // 将链接地址字符内容转变成blob地址
            a.href = URL.createObjectURL(blob)
            a.download = row.display // 下载文件的名字
            document.body.appendChild(a)
            a.click()
          })
      } else {
        let eleLink = document.createElement('a')
        eleLink.download = row.display // 下载文件的名字
        eleLink.href = res
        eleLink.click()
        eleLink.remove()
      }
    }
  },
  computed: {
    // 问题汇总表高度
    tableHeight() {
      const headerHeight = 80
      const cardMaring = 15 * 2
      const cardPadding = 10 * 2
      const button = 40
      const elForm = 65 * 2
      const divider = this.$store.state.ykDivider
      return (
        Number(this.$store.state.clientHeight) - headerHeight - cardMaring - cardPadding - elForm - divider - button
      )
    },
    // checkList表高度
    checkListTableHeight() {
      const headerHeight = 80
      const cardMaring = 15 * 2
      const cardPadding = 10 * 2
      const button = 40
      const elForm = 65 * 2
      // 因为checkList上下摆放，因此需要减掉2个ykDivider的高度
      const divider = this.$store.state.ykDivider * 2
      return (
        (Number(this.$store.state.clientHeight) - headerHeight - cardMaring - cardPadding - elForm - divider - button) /
        2
      )
    },
    // 是否制单人本人
    isWriter() {
      return this.form.writerID === this.$store.state.userInfo.userId
    },
    // 是否已下发
    isIssued() {
      return this.ykDateFormat('yyyy-MM-dd', this.form.issuedDate) !== ''
    },
    // 当前单据所处列表的位置
    currentIDPos() {
      return this.allIssuedFlowID.findIndex(id => this.id === id)
    }
  },
  watch: {
    form: {
      handler() {
        if (this.IfDataBindComplete) {
          this.IfExistModify = true
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.card {
  height: calc(100vh - @header-height - (@main-margin * 2));
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
  padding: 10px;
}

// 明细数据中的右边部分（checkList，为了看得清除需要可滚动）
.detail-right-dv {
  overflow-y: scroll;
  padding-right: 10px;
  .scrollbar-mixin();
}

.buttonContainer {
  width: 100%;
  // display: flex;
  // justify-content: center;
}

.expand-btn-dv {
  height: 100px;
  // divider 高度 = 33px
  margin-top: 33px;
  flex-wrap: wrap;
  .fl();

  // 隐藏左侧表格
  .expand-btn {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: #fff;
    background-color: #ddd;
    // position: absolute;
    right: -2px;
    top: 50%;
    transition: all 0.2s ease-in-out;
    .fl();

    &:hover {
      cursor: pointer;
      background-color: #ccc;
    }

    i {
      font-size: 14px;
    }
  }

  .rotate-icon {
    transform: rotate(180deg);
    // padding: 0 10px;
    // position: relative;
  }
}

// 表格切换动画
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
